import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { AxiosInterceptor } from './services/api';
import PrivateRoute from './components/auth/PrivateRoute';

// 页面组件
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import InspectionPage from './pages/inspection/InspectionPage';
import TrainingPage from './pages/training/TrainingPage';
import CertificatePage from './pages/certificate/CertificatePage';
import SystemPage from './pages/system/SystemPage';
import NotFoundPage from './pages/NotFoundPage';

// 布局组件
import MainLayout from './layouts/MainLayout';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <AxiosInterceptor>
          <Router>
            <Routes>
              {/* 登录页 */}
              <Route path="/login" element={<LoginPage />} />
              
              {/* 主应用路由 */}
              <Route path="/" element={
                <PrivateRoute>
                  <MainLayout />
                </PrivateRoute>
              }>
                <Route index element={<Navigate to="/dashboard" replace />} />
                <Route path="dashboard" element={<DashboardPage />} />
                <Route path="inspections/*" element={<InspectionPage />} />
                <Route path="trainings/*" element={<TrainingPage />} />
                <Route path="certificates/*" element={<CertificatePage />} />
                <Route path="system/*" element={<SystemPage />} />
              </Route>
              
              {/* 404页面 */}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Router>
        </AxiosInterceptor>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;